/** The "Visits merged" toast's id, so an unmerge from anywhere can take down its stale Undo. */
export const mergedToastId = (mergeId: string) => `visit-merged-${mergeId}`;

/** The "Unmerged" toast's id, so two paths that both see the same unmerge show it once. */
export const unmergedToastId = (mergeId: string) => `visit-unmerged-${mergeId}`;
